import { render, staticRenderFns } from "./HeaderItem.vue?vue&type=template&id=7e4c8bcb&"
import script from "./HeaderItem.vue?vue&type=script&lang=js&"
export * from "./HeaderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e4c8bcb')) {
      api.createRecord('7e4c8bcb', component.options)
    } else {
      api.reload('7e4c8bcb', component.options)
    }
    module.hot.accept("./HeaderItem.vue?vue&type=template&id=7e4c8bcb&", function () {
      api.rerender('7e4c8bcb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/meeting-agendas/items/HeaderItem.vue"
export default component.exports